var $ = require('jquery');

$(function () {
    $('.ws-pill--dismissible').on('click', function () {
        $(this).fadeOut(500, function () {
            $(this).parents('.ws-pill__label').remove();
        });
    });
});